<template>
  <div>
  <!-- Escritorio: tabla. En movil (< 768px) se usan las tarjetas de abajo -->
  <div class="table-responsive d-none d-md-block">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Tienda a Pedir</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Fecha Ultima Edición</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.tienda_pedir.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
          <td class="text-center"></td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>

  <!-- Movil: una tarjeta por requerimiento con toda su informacion -->
  <div class="d-md-none" v-if="dataTabla && dataTabla.results">
    <div v-if="dataTabla.results.length === 0" class="text-center text-muted py-3">
      No hay requerimientos para mostrar.
    </div>
    <button v-for="current in dataTabla.results" :key="'movil_' + current.id" type="button" class="req-item"
      :class="{
        'req-item-abierto': current.estado == 'A',
        'req-item-cerrado': current.estado == 'B',
        'req-item-anulado': current.estado == '9',
      }" @click="rowClick(current)">
      <div class="req-item-fila">
        <b>#{{ current.numero }}</b>
        <span class="badge" :class="{
          'badge-success': current.estado == 'A',
          'badge-warning': current.estado == 'B',
          'badge-danger': current.estado == '9',
        }">{{ current.estado_str }}</span>
      </div>
      <div class="req-item-tienda">{{ current.tienda.nombre }}</div>
      <small class="d-block"><span class="text-muted">Pide a:</span> {{ current.tienda_pedir.nombre }}</small>
      <div class="req-item-fila mt-1">
        <small class="text-muted">{{ current.fecha }} &middot; {{ nombreUsuario(current.usuario) }}</small>
        <small class="text-muted text-right">
          <timeago :title="current.fecha_creacion" :datetime="current.fecha_creacion"></timeago>
        </small>
      </div>
    </button>
  </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props:["dataTabla"],
  computed: {
    ...mapGetters({

    }),
  },
  mounted() {
    // El listado lo carga el componente padre (ReqTrasladoComponent) con sus filtros.
    // Aqui se hacia una segunda consulta sin filtros cuyo resultado no se usaba.
  },
  methods: {
    // Si el usuario no tiene nombre/apellido, name llega en blanco: se usa el username
    nombreUsuario(usuario) {
      if (!usuario) {
        return "";
      }
      return (usuario.name || "").trim() || usuario.username || "";
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-req_traslado-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-req_traslado-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("reqtraslado/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>

<style scoped>
/* Listado en tarjetas (movil) */
.req-item {
  display: block;
  width: 100%;
  text-align: left;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-left-width: 4px;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.req-item:active,
.req-item:hover {
  background-color: #f3f7ff;
}

.req-item-abierto {
  border-left-color: #24b314;
}

.req-item-cerrado {
  border-left-color: #f8bc34;
}

.req-item-anulado {
  border-left-color: #e65252;
}

.req-item-fila {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.req-item-tienda {
  font-size: 0.95rem;
  margin-top: 2px;
  overflow-wrap: anywhere;
}
</style>
